import React, { useRef } from "react";
import { motion } from "motion/react";

import useRipple from "../../hooks/useRipple";
import "../../hooks/useRipple.css";
import { convertToIST } from "../../shared/utils/formatDate";
import { uploadTypeToLabelMap } from "../../constants/bulkJobConstants";
import dropdown_icon from "../../assets/images/dropdown_icon.svg";

const JobCard = ({ job, expandedJobId, handleToggleDetails }) => {
  const detailsButtonRef = useRef(null);
  useRipple(detailsButtonRef);

  const getStatusStyle = (status) => {
    const statusColors = {
      completed: { background: "#B1F3BA" },
      "in-progress": { background: "#FFD9A8" },
      "partially completed": { background: "#FD7E14" },
      failed: { background: "#FFC9C9" },
    };
    return statusColors[status];
  };

  const isExpanded = expandedJobId === job.job_id;

  return (
    <div className={`job-card ${isExpanded ? "expanded" : ""}`}>
      <div style={{ padding: "24px" }}>
        <div className="job-card-header">
          <div className="job-id">
            {job.job_id} &nbsp;&nbsp;|&nbsp;&nbsp; Uploaded at :{" "}
            {convertToIST(job.uploaded_at)}
            &nbsp;&nbsp;|&nbsp;&nbsp; Type :{" "}
            {uploadTypeToLabelMap[job.upload_type] || job.upload_type}
          </div>
          <div className="job-status" style={getStatusStyle(job.status)}>
            {job.status}
          </div>
        </div>
        <div className="job-details">
          <div className="job-stats">
            <span className="stat-item total-records">
              Total Records : {job.total_records}
            </span>
            <span className="stat-item success-count">
              Success : {job.success_count}
            </span>
            <span className="stat-item failed-count">
              Failed : {job.failed_count}
            </span>
          </div>
          {job.estimated_completion && (
            <div className="job-meta">
              <span className="completion-time">
                Estimated Completion time: {job.estimated_completion}
              </span>
            </div>
          )}
        </div>
        <div className="card-footer">
          <div className="uploader-info">Uploaded by : {job.uploaded_by}</div>
          <button
            ref={detailsButtonRef}
            className="view-details"
            onClick={() => handleToggleDetails(job)}
            style={{ overflow: "hidden", position: "relative" }}
          >
            {isExpanded ? "Hide Details" : "View Details"}
            <motion.img
              src={dropdown_icon}
              animate={{ rotate: isExpanded ? 180 : 0 }}
              transition={{ duration: 0.3, ease: "easeInOut" }}
            />
          </button>
          {job.failed_records_url && (
            <a href={job.failed_records_url} download className="view-details">
              Download Failed Records
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default JobCard;
